import { useState, useRef } from 'react'
import jsPDF from 'jspdf'
import html2canvas from 'html2canvas'
import FacturaPreviewPDF from '../../../../../table/typesExportPDF/FacturaPreviewPDF'

export default function PrevisualizacionFacturaIndividual({
  document,
  currentBusiness,
  totals, // ya no lo usamos, pero lo dejo por compatibilidad
  onBack, // Corregir
  onEmit, // función que emite la factura
  isSubmitting // Firmar
}) {
  const empresaRut = currentBusiness?.rut || document?.document_issuer?.rut || '—'
  const [accepted, setAccepted] = useState(false)
  const printRef = useRef()

  const handleEmitClick = () => {
    if (!accepted || isSubmitting) return
    onEmit()
  }

  const handleDownloadPdf = async () => {
    const element = printRef.current
    const canvas = await html2canvas(element, { scale: 2, useCORS: true })
    const data = canvas.toDataURL('image/png')
    const pdf = new jsPDF({ orientation: 'portrait', unit: 'px', format: 'a4' })
    const imgProperties = pdf.getImageProperties(data)
    const pdfWidth = pdf.internal.pageSize.getWidth()
    const pdfHeight = (imgProperties.height * pdfWidth) / imgProperties.width
    pdf.addImage(data, 'PNG', 0, 0, pdfWidth, pdfHeight)
    pdf.save(`Factura_${document?.folio || 'preview'}.pdf`)
  }

  return (
    <div className='space-y-6'>
      {/* ENCABEZADO TIPO SII */}
      <header className='flex items-start justify-between'>
        <div>
          <h1 className='text-xl md:text-2xl font-semibold'>
            REVISIÓN DE DOCUMENTO TRIBUTARIO ELECTRÓNICO
          </h1>
          <p className='text-sm text-gray-700 mt-2 max-w-4xl'>
            Este es el Documento Tributario Electrónico que se ha generado con la información que
            Ud. ha ingresado hasta ahora.{' '}
            <span className='font-semibold'>
              Revíselo cuidadosamente para verificar que contiene todos los datos que Ud. desea
              incorporar en el documento.
            </span>
          </p>
        </div>

        <div className='text-sm mt-1 whitespace-nowrap'>
          <span className='text-gray-700 mr-1'>Empresa:</span>
          <span className='font-semibold'>{empresaRut}</span>
        </div>
      </header>

      {/* VISOR PDF SIEMPRE EXPANDIDO */}
      <section className='bg-white rounded-2xl shadow p-4'>
        <div className='overflow-auto' style={{ maxHeight: '80vh' }}>
          <FacturaPreviewPDF
            document={document}
            currentBusiness={currentBusiness}
            printRef={printRef}
          />
        </div>
      </section>
      <section className='flex justify-center'>
        <button
          onClick={handleDownloadPdf}
          className='cursor-pointer rounded-lg bg-primary px-6 py-2.5 text-sm font-bold text-white shadow-lg shadow-black/20 transition-all hover:bg-primary/90 active:scale-95'
          style={{
            padding: '10px 20px',
            backgroundColor: '#000033',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontWeight: 'bold'
          }}
        >
          Descargar PDF
        </button>
      </section>
      <section className='space-y-4'>
        <div className='text-sm text-gray-800 '>
          <p>
            Si está de acuerdo con el documento desplegado y quiere emitir este documento, presione
            el botón <span className='font-semibold'>Firmar</span>. Si quiere volver al documento
            para realizar correcciones o agregar información, presione el botón{' '}
            <span className='font-semibold'>Corregir</span>.
          </p>
        </div>

        {/* Checkbox de términos / aceptación */}
        <div className='border rounded-xl p-6 bg-gray-50'>
          <div className='flex items-start gap-2 text-sm'>
            <input
              type='checkbox'
              className='mt-1'
              checked={accepted}
              onChange={e => setAccepted(e.target.checked)}
            />
            <p>
              Acepto emitir los documentos al SII. Al marcar esta casilla, confirmo que he revisado
              todos los datos y autorizo su emisión.
            </p>
          </div>

          <div className='flex justify-center items-center gap-4 mt-6'>
            <button
              type='button'
              onClick={handleEmitClick}
              disabled={!accepted || isSubmitting}
              className='cursor-pointer rounded-lg bg-primary px-6 py-2.5 text-sm font-bold text-white shadow-lg shadow-black/20 transition-all hover:bg-primary/90 active:scale-95 disabled:opacity-60 disabled:cursor-not-allowed'
            >
              {isSubmitting ? 'Firmando...' : 'Firmar'}
            </button>

            <button type='button' onClick={onBack} className='cursor-pointer rounded-lg bg-primary px-6 py-2.5 text-sm font-bold text-white shadow-lg shadow-black/20 transition-all hover:bg-primary/90 active:scale-95'>
              Corregir
            </button>
          </div>
        </div>
      </section>
    </div>
  )
}
